import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeLayoutComponent } from './layouts/home-layout/home-layout.component';
import { InnerPagesLayoutComponent } from './layouts/inner-pages-layout/inner-pages-layout.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { PageUnsubscribeComponent } from './pages/page-unsubscribe/page-unsubscribe.component';
import { siteModule } from './globals/constants';

// NOTE: loadChildren uses the dynamic import() form (not `() => SomeModule`). The old
// synchronous module-reference form failed to activate the child route when navigating
// from the home layout into a shared InnerPagesLayout lazy module for the FIRST time —
// the layout mounted but its <router-outlet> stayed empty (blank page until a reload).
const routes: Routes = [
  {
    path: siteModule.HOME,
    component: HomeLayoutComponent,
    loadChildren: () => import('./routing-modules/home-routing/home-routing.module').then(m => m.HomeRoutingModule)
  },
  {
    path: siteModule.COMPANY,
    component: InnerPagesLayoutComponent,
    loadChildren: () => import('./routing-modules/company-routing/company-routing.module').then(m => m.CompanyRoutingModule)
  },
  {
    path: siteModule.ITSOLUTIONS,
    component: InnerPagesLayoutComponent,
    loadChildren: () => import('./routing-modules/it-solutions-routing/it-solutions-routing.module').then(m => m.ItSolutionsRoutingModule)
  },
  {
    path: siteModule.ITBLOGS,
    component: InnerPagesLayoutComponent,
    loadChildren: () => import('./routing-modules/it-blogs-routing/it-blogs-routing.module').then(m => m.ItBlogsRoutingModule)
  },
  {
    // Public unsubscribe landing (linked from campaign emails): /unsubscribe?token=...
    path: 'unsubscribe',
    component: InnerPagesLayoutComponent,
    children: [{ path: '', component: PageUnsubscribeComponent }]
  },
  {
    // Catch-all: any unknown URL renders the 404 inside the inner layout (header + footer).
    path: '**',
    component: InnerPagesLayoutComponent,
    children: [{ path: '', component: PageNotFoundComponent }]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
